<template>
  <v-container>
    <v-card>
      <v-card-title class="primary white--text">
        <v-icon>fas fa-chart-line</v-icon>
        <span class="ml-2 title">Resultados de la encuesta</span>
        <v-spacer />
        <v-btn
          fab
          small
          color="secondary"
          @click="$router.go(-1)"
        >
          <v-icon>fas fa-arrow-left</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <v-row>
          <v-col cols="12" sm="6" md="4">
            <v-btn
              block
              dark
              color="green"
              @click="getExcelEncuesta()"
            >Exportar datos</v-btn>
          </v-col>
        </v-row>
        <v-data-table
          :headers="headers"
          :items="respuestas"
          :items-per-page="25"
        ></v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import http from '../mixins/http'
export default {
  mixins: [http],
  props: {
    id: {
      type: String,
      default: () => null
    }
  },
  data () {
    return {
      headers: [],
      respuestas: []
    }
  },
  created () {
    this.getRespuestas()
  },
  methods: {
    async getRespuestas () {
      const { data } = await this.$http.preguntas.get(`?encuesta=${this.id}`)
      this.headers = data.map((item, index) => {
        return {
          text: item.pregunta,
          value: `p${index}`,
          sortable: false
        }
      })
      const resp = data.map((item, index) => ({ value: `p${index}`, respuestas: item.respuestas.map(i => item.tipo === 'vf' ? i.verdadero_falso : i.texto) }))
      const len = resp[0].respuestas.length
      const respuestas = []
      for (let i = 0; i < len; i++) {
        const res = {}
        for (const item of resp) {
          let value = null
          if (typeof item.respuestas[i] === 'boolean') {
            value = item.respuestas[i] ? 'Si' : 'No'
          } else {
            value = item.respuestas[i]
          }
          res[item.value] = value
        }
        respuestas.push(res)
      }
      this.respuestas = respuestas
    },
    getExcelEncuesta () {
      this.getExcel(`/encuestas/${this.id}/csv`, 'datos')
    }
  }
}
</script>
